import React from 'react';
import ReactDOM from  'react-dom';

import {
  Popover,
  OverlayTrigger,
  Button,
  ButtonToolbar
} from 'react-bootstrap';


export default class DeleteBtnWithConfirm extends React.Component {
  constructor(props) {
    super(props);
    
    // 處理在popover中以ReactDOM.findDOMNode(this.refs.target).click()
    // 觸發關閉popover點擊事件會導致確認鈕的handler觸發2次的bug
    this.bugCover = 0;

    this.handlers = {
      onCancelDelClick: () => {
        if(this.bugCover < 1) {
          this.bugCover++;
          if(this.props.onCancelClick) this.props.onCancelClick();
          ReactDOM.findDOMNode(this.refs.target).click();
        }else this.bugCover = 0;
        
      },
      onDoDelClick: e => {
        if(this.bugCover < 1) {
          this.bugCover++;

          if(this.props.onClick) this.props.onClick();

          ReactDOM.findDOMNode(this.refs.target).click();
        }else this.bugCover = 0;
      }
    };
  }

  render() {
    const {languageData, languageCode} = window.myConsts;

    const popoverClick = (
      <Popover id="popover-trigger-click" title={this.props.title || languageData['179'][languageCode]}>
        <ButtonToolbar>
          <Button style={{float: 'right'}} onClick={this.handlers.onCancelDelClick}>{languageData['67'][languageCode]}</Button>
          <Button style={{float: 'right'}} onClick={this.handlers.onDoDelClick}>{languageData['81'][languageCode]}</Button>
        </ButtonToolbar>
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement={this.props.placement || "left"} overlay={popoverClick}>
        <Button
          id={this.props.id}
          style={this.props.style}
          className={this.props.className}
          ref="target"
          disabled={this.props.disabled}>
          {this.props.btnTitle || languageData['232'][languageCode]}
        </Button>
      </OverlayTrigger>
    );
  }
}




// WEBPACK FOOTER //
// ./src/commonComponents/DeleteBtnWithConfirm.jsx